import * as React from "react";

function EvaluationForms({color="var(--color-blue-500)",...props}) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22 22" fill="none" {...props}>
      <path
        d="M10.408 21.674c-2.21 0-4.528-.056-6.158-.151-1.362-.08-2.47-.783-3.2-2.035-.581-.996-.79-2.11-.79-2.822-.015-1.253-.01-3.75-.005-6.409v-.116C.258 8.719.26 7.248.26 5.887.26 1.225 3.19.48 4.484.379A26.837 26.837 0 019.026.194a.75.75 0 11-.063 1.499 25.547 25.547 0 00-4.344.18c-1.304.095-2.86.868-2.86 4.015 0 1.362-.002 2.834-.005 4.257l-.001.47c-.005 2.519-.01 4.846.007 6.042 0 .687.437 3.244 2.576 3.369 3.067.178 8.592.218 11.119 0h.01l.01-.001c.024-.001 2.292-.156 2.552-2.394a34.39 34.39 0 00.236-4.5l-.001-.121-.001-.072a.75.75 0 011.5 0c0 .044 0 .103.002.176v.009c.007.65.026 2.353-.246 4.68-.322 2.774-2.714 3.644-3.944 3.718-1.234.105-3.156.15-5.166.15v.003z"
        fill={color}
      />
      <path
        d="M14.98 8.189h-.039a.748.748 0 01-.632-.414c-.433-.867-.855-1.301-.86-1.305a.75.75 0 111.061-1.061c.036.036.247.253.527.654.651-.843 1.67-1.968 2.693-2.331a.75.75 0 01.501 1.413c-.85.3-2.057 1.813-2.618 2.695a.75.75 0 01-.633.348z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.24 5.939a5.76 5.76 0 005.755 5.75 5.759 5.759 0 005.755-5.75 5.759 5.759 0 00-5.755-5.75 5.759 5.759 0 00-5.755 5.75zm1.5 0c0-2.343 1.91-4.25 4.255-4.25a4.258 4.258 0 014.255 4.25 4.258 4.258 0 01-4.255 4.25 4.258 4.258 0 01-4.255-4.25z"
        fill={color}
      />
      <path
        d="M9.98 12.689h-4a.75.75 0 010-1.5h4a.75.75 0 010 1.5zM5.98 16.689h8a.75.75 0 000-1.5h-8a.75.75 0 000 1.5z"
        fill={color}
      />
    </svg>
  );
}

export default EvaluationForms;
